import React, { Suspense } from 'react';
import { SwordIcon } from 'lucide-react';
import { TroveGenrePage } from '../../components/Trove/TroveGenrePage';
import type { TroveArticle, TroveEvent, TroveNominee } from '../../components/Trove/TroveGenrePage';
import type { ActivityPost } from '../../components/Trove/ActivityPostCard';
const activityPosts: ActivityPost[] = [{
  id: 1,
  type: 'New Release',
  title: 'The Thursday Murder Club — Book 4',
  description: "Richard Osman's beloved mystery series returns with another gripping instalment.",
  author: 'Richard Osman',
  date: 'Oct 15, 2023',
  genre: 'Mystery'
}, {
  id: 2,
  type: 'Sale',
  title: 'Thriller Bundle — 5 Books for $9.99',
  description: 'Five bestselling indie thrillers available at a limited-time bundle price.',
  author: 'Various Authors',
  date: 'Oct 14, 2023',
  genre: 'Thriller'
}, {
  id: 3,
  type: 'Collaboration Request',
  title: 'Mystery ARC Readers Wanted',
  description: 'Seeking advance readers for a cozy mystery series set in a Scottish village. Feedback required within 3 weeks.',
  author: 'Claire MacAllister',
  date: 'Oct 13, 2023',
  genre: 'Mystery'
}, {
  id: 4,
  type: 'Event Announcement',
  title: 'Bouchercon World Mystery Convention 2024',
  description: "The world's largest mystery fan convention returns. Early bird registration now open.",
  author: 'Bouchercon',
  date: 'Oct 12, 2023',
  genre: 'Mystery'
}, {
  id: 5,
  type: 'Vendor Availability',
  title: 'Thriller Cover Designer — Q1 Slots Available',
  description: 'Dark, atmospheric cover designs for thriller and crime fiction. Portfolio available on request.',
  author: 'Dark Matter Design',
  date: 'Oct 11, 2023',
  genre: 'Thriller'
}];
const articles: TroveArticle[] = [{
  id: 1,
  title: 'Crafting the Perfect Plot Twist',
  excerpt: 'Expert tips on writing unexpected reveals that keep readers guessing...',
  author: 'James Patterson',
  date: 'October 8, 2023',
  category: 'Mystery',
  readTime: '8 min read',
  image: 'https://images.unsplash.com/photo-1509347528160-9a9e33742cdb?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  id: 2,
  title: 'Psychology of Suspense',
  excerpt: 'Understanding the psychological elements that make thrillers effective...',
  author: 'Lisa Gardner',
  date: 'October 5, 2023',
  category: 'Thriller',
  readTime: '10 min read',
  image: 'https://images.unsplash.com/photo-1590856029826-c7a73142bbf1?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}];
const interviews: TroveArticle[] = [{
  id: 105,
  title: 'Gillian Flynn on Creating Unforgettable Characters in Psychological Thrillers',
  excerpt: 'The bestselling author of "Gone Girl" discusses her approach to character development...',
  author: 'Thriller Writers Association',
  date: 'October 10, 2023',
  category: 'Thriller',
  readTime: '13 min read',
  image: 'https://images.unsplash.com/photo-1551269901-5c5e14c25df7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  type: 'interview'
}, {
  id: 106,
  title: 'Tana French on Setting and Atmosphere in Mystery Fiction',
  excerpt: 'The acclaimed Dublin Murder Squad author shares techniques for creating immersive settings...',
  author: 'Mystery Writers Guild',
  date: 'October 6, 2023',
  category: 'Mystery',
  readTime: '15 min read',
  image: 'https://images.unsplash.com/photo-1587876931567-564ce588bfbd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  type: 'interview'
}];
const podcasts: TroveArticle[] = [{
  id: 205,
  title: 'Criminal',
  excerpt: "Stories of people who've done wrong, been wronged, or gotten caught somewhere in the middle...",
  author: 'Phoebe Judge',
  date: 'Bi-weekly',
  category: 'True Crime & Mystery',
  readTime: '30-40 min episodes',
  image: 'https://images.unsplash.com/photo-1588860939994-ce4f7a537f03?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  type: 'podcast'
}, {
  id: 206,
  title: 'Thriller Writers Podcast',
  excerpt: 'Interviews with bestselling thriller authors about craft, career, and the writing life...',
  author: 'Alex Callister',
  date: 'Weekly',
  category: 'Thriller',
  readTime: '45-60 min episodes',
  image: 'https://images.unsplash.com/photo-1585647347483-22b66260dfff?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  type: 'podcast'
}];
const upcomingEvents: TroveEvent[] = [{
  name: 'Bouchercon 2024',
  date: 'Nov 8, 2023',
  location: 'Nashville, TN'
}, {
  name: 'Crime Writers Association Gala',
  date: 'Dec 5, 2023',
  location: 'London, UK'
}];
const awardNominees: TroveNominee[] = [{
  id: 1,
  name: 'The Thursday Murder Club',
  author: 'Richard Osman',
  votes: 2841
}, {
  id: 2,
  name: 'Gone Girl',
  author: 'Gillian Flynn',
  votes: 2587
}];
const MysteryThrillerTrove = () => <TroveGenrePage title="Mystery & Thriller" subtitle="Uncover writing techniques, genre insights, and the art of suspense" icon={<SwordIcon className="h-6 w-6" data-id="element-17247" data-mp="2fywrxnwelynw" />} searchPlaceholder="Search mystery & thriller content..." activityPosts={activityPosts} articles={articles} interviews={interviews} podcasts={podcasts} upcomingEvents={upcomingEvents} awardNominees={awardNominees} articlesHref="/trove/mystery-thriller/articles" data-id="element-17246" data-mp="2b7559ogdcd31" />;
export default MysteryThrillerTrove;